<template>
    <v-card outlined class="chart-panel fill-height">
        <div class="d-flex align-center flex-wrap px-4 pt-3">
            <span class="chart-panel__title">{{ title }}</span>
            <v-spacer></v-spacer>
            <slot name="actions"></slot>
        </div>
        <v-card-text>
            <ChartCanvas :type="type" :labels="labels" :datasets="datasets" :options="options" :loading="loading"
                :error="error" :empty-text="emptyText" :aria-label="title" :height="height"></ChartCanvas>
        </v-card-text>
    </v-card>
</template>
<script>
import ChartCanvas from '@/components/shared/ChartCanvas.vue';

/**
 * Tarjeta del Dashboard con una gráfica: título, acciones opcionales (slot `actions`) y `ChartCanvas`.
 * `data` es la serie única; `datasets` se calcula aquí para que no sea un arreglo nuevo en cada render del padre
 * (ChartCanvas lo vigila en profundidad).
 */
export default {
    name: 'ChartPanel',
    components: { ChartCanvas },
    props: {
        title: { type: String, required: true },
        type: { type: String, default: 'bar' },
        labels: { type: Array, default: () => [] },
        data: { type: Array, default: () => [] },
        label: { type: String, default: 'Monto' },
        options: { type: Object, default: () => ({}) },
        loading: { type: Boolean, default: false },
        error: { type: String, default: '' },
        emptyText: { type: String, default: 'Sin datos en el periodo' },
        height: { type: String, default: '260px' }
    },
    computed: {
        datasets() {
            return [{ label: this.label, data: this.data }];
        }
    }
};
</script>
<style scoped>
/* Sin clases `text-*` de Vuetify: main.css les cambia la fuente. */
.chart-panel__title {
    font-size: 1rem;
    font-weight: 700;
}
</style>
